import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap'
import { Translate, components, Actions as actions } from 'unity-core'
const { NavLink } = components
import { bindActionCreators } from 'redux'

const propTypes = {
  error: PropTypes.string,
  errorDescription: PropTypes.string,
  err: PropTypes.object,
  notice: PropTypes.object,
  strings: PropTypes.object.isRequired,
  clearErr: PropTypes.func.isRequired,
}

const defaultProps = {
  err: null,
  notice: {}
}

export class SSOError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {

    return (
      <div className="login-container">
        <Grid fluid className="slide-top-100">
          <Row>
            <Col md={12}>
              <div>
                <br />
              </div>
              <div class="notice notice-error">
                <div class="notice-content">
                  <div class="notice-title"><b>Login Failure</b></div>
                  <div class="notice-body">
                    <hr />
                    <div>
                      <p><b>
                        {this.props.errorDescription
                          ? this.props.errorDescription
                          : "An issue occurred while tyring to sign you in"
                        }
                      </b></p>
                      <p
                      >Please report this issue to <a href="mailto:UnitySupportTeam@dnb.com">UnitySupportTeam@dnb.com</a> for further assistance
                      </p>
                      <br />
                      <p>
                        You can still log in using this legacy link while we work on resolving your issue  <NavLink to="/legacy-login">Use Legacy login</NavLink>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

SSOError.propTypes = propTypes
SSOError.defaultProps = defaultProps

const mapStateToProps = (state, ownProps) => ({
  query: ownProps.location.query,
  error: ownProps.location.query.error,
  errorDescription: ownProps.location.query.error_description,
  notice: state.app.notice,
  lang: state.user.lang,
  err: state.user.err
});

const mapDispatchToProps = (dispatch) => ({
  clearErr: bindActionCreators(actions.User.clearErr, dispatch),
})

const decorators = _.flow([
  connect(mapStateToProps, mapDispatchToProps),
  Translate('Login', 'ForgotPassword')
]);

export default decorators(SSOError)
